"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var theme_1 = require("../../../util/responsive/theme");
/** 组装theme
 * 其实这个应该是扩展自pie的，anyway，先这样写
 */
var ringTheme = {
    ring: {
        constraints: [{ name: 'ringThickness' }, { name: 'minRingThickness' }],
    },
};
theme_1.registerResponsiveTheme('ring', ringTheme);
//# sourceMappingURL=theme.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/ring/apply-responsive/theme.js
// module id = 964
// module chunks = 37